import { Fragment, h, render } from 'preact';
import { useState } from 'preact/hooks';
import { currency } from '../../../src/ts/libs/currency';
import { getApi } from '../../../src/ts/libs/getApi';
import { useFetch } from '../hooks/useFetch';
import { Error } from './../error/Error';

export interface SellingUnit {
  name: string;
  active: boolean;
  id: any;
  price: number;
  oldprice?: number;
}

export interface ProductProps {
  id: number;
  iqid: number;
  sellingUnitName: string;
  sellingUnit: string;
  sellingUnits: SellingUnit[];
}

const rootEl = document.querySelector('#add-to-basket-dynamic');

const getProduct = () => {
  try {
    return JSON.parse(document.getElementById('add-to-basket-data').innerHTML);
  } catch (e) {
    return null;
  }
};
if (rootEl) {
  const productDefault: ProductProps = getProduct();
  const AddToBasket = () => {
    const [qty, setQuantity] = useState(1);
    const [sellingUnit, setSellingUnit] = useState(productDefault.sellingUnit);
    const [product, setProduct] = useState<ProductProps>(productDefault);
    const { response, fetchData: updateQuantity, loading, error: updateBasketQuantityError } = useFetch(
      `${getApi('updateBasketQuantity')}`,
      {}
    );
    const { fetchData: addToCart, error: addBasketError } = useFetch(`${getApi('addToBasket')}`, {});

    const handleChangeUnit = (evt) => {
      setSellingUnit(evt.currentTarget.value);
    };

    const handleRemoveOne = () => {
      // set the value first
      setQuantity((c) => {
        const newVal = c === 1 ? 1 : +c - 1;

        // update api
        updateQuantity(
          {
            method: 'PUT',
          },
          {
            productCode: product?.id,
            quantity: newVal,
          }
        );

        // optimistically set qunatity
        return newVal;
      });
    };
    const handleAddOne = () => {
      // set the value first
      setQuantity((c) => {
        const newVal = +c + 1;

        // update api
        updateQuantity(
          {
            method: 'PUT',
          },
          {
            productCode: product?.id,
            quantity: newVal,
          }
        );

        // optimistically set qunatity
        return newVal;
      });
    };
    const handleAddToBasket = () => {
      // Post off basket update

      addToCart({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          productCode: product.id,
          quantity: qty,
          sellingUnit: sellingUnit,
        }),
      });

      const image = document.querySelector('.product-gallery__main img');
      const el = document.querySelector('#mini-cart .basket-blade-action__icon');

      if (!image || !el) {
        return;
      }

      const { left: startLeft, top: startTop, width, height } = image.getBoundingClientRect();
      const { left: targetLeft, top: targetTop } = el.getBoundingClientRect();

      const wrap = document.createElement('div');
      wrap.classList.add('moving-card');
      wrap.appendChild(image.cloneNode());

      wrap.style.top = `${startTop}px`;
      wrap.style.left = `${startLeft}px`;
      wrap.style.width = `${width}px`;
      wrap.style.height = `${height}px`;
      document.body.appendChild(wrap);
      setTimeout(() => {
        wrap.style.top = `${targetTop}px`;
        wrap.style.left = `${targetLeft}px`;
        wrap.classList.add('to-end');
      }, 100);
      setTimeout(() => {
        wrap.remove();
        const event = new Event('basket-update');
        window.dispatchEvent(event);
      }, 1500);

      // call event to notify the mini basket
    };

    if (!product) {
      return null;
    }

    const currentProduct = product.sellingUnits.find((p) => p.id == sellingUnit);

    return (
      <Fragment>
        <div className="product-spec" data-test="add-to-basket">
          <div className="product-spec__price">
            <div className="product-spec__price__current">
              <strong>{currency(currentProduct.price)}</strong> Ex VAT. ({currentProduct.name})
            </div>
            {/* {currentProduct?.oldprice && (+currentProduct.oldprice > +currentProduct.price) && (

              <div className="product-spec__price__sale">
                <span className="product-spec__price__was">Was <em>{currency(currentProduct.oldprice)}</em></span>
                <span className="product-spec__price__save">{' '}Save {currency(currentProduct.oldprice - currentProduct.price)}</span>
              </div>)
            } */}
          </div>

          {product?.sellingUnits && product.sellingUnits.length > 1 && (
            <div className="product-spec__features">
              <h3 className="product-spec__features__heading">Available selling units</h3>
              <ul className="product-spec__list">
                {product?.sellingUnits &&
                  product.sellingUnits.map((p) => (
                    <li key={p.id}>
                      {p.name}
                      {' - '}
                      {currency(p.price)}
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
        <div className="add-to-basket">
          <form className="form">
            <div className="form-field">
              <label className="form-field__label" htmlFor="quantity">
                Quantity
              </label>
              <div className="quantity-control">
                <button
                  type="button"
                  className={`button button--muted ${loading ? 'is-loading' : ''}`}
                  onClick={handleRemoveOne}
                  data-test="add-to-basket-minus"
                >
                  <span className="button__label sr-only">Minus one from quantity</span>
                  <svg aria-hidden="true" width={12} height={4} xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.333 3.037c0 .244-.2.444-.444.444H1.11a.446.446 0 01-.444-.444V.963c0-.244.2-.444.444-.444h9.778c.244 0 .444.2.444.444v2.074z"
                      fill="currentColor"
                      fillRule="evenodd"
                    />
                  </svg>
                </button>
                <input
                  name="quantity"
                  id="basket-quantity"
                  value={qty}
                  type="number"
                  aria-label="Enter Quanity"
                  data-test="add-to-basket-qty"
                />
                <button
                  type="button"
                  className={`button button--muted ${loading ? 'is-loading' : ''}`}
                  onClick={handleAddOne}
                  data-test="add-to-basket-plus"
                >
                  <span className="button__label sr-only">Plus one to quantity</span>
                  <svg aria-hidden="true" width={12} height={12} xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.333 7.037c0 .244-.2.444-.444.444H7.48v3.408c0 .244-.2.444-.444.444H4.963a.446.446 0 01-.444-.444V7.48H1.11a.446.446 0 01-.444-.444V4.963c0-.244.2-.444.444-.444H4.52V1.11c0-.244.2-.444.444-.444h2.074c.244 0 .444.2.444.444V4.52h3.408c.244 0 .444.2.444.444v2.074z"
                      fill="currentColor"
                      fillRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div className="form-field">
              <label className="form-field__label" htmlFor="sellingUnit">
                Selling unit
              </label>
              <select name="sellingUnit" id="sellingUnit" className="select" onChange={handleChangeUnit}>
                {product?.sellingUnits.length >= 1 &&
                  product.sellingUnits.map((item) => (
                    <option key={item.id} value={item.id} selected={sellingUnit === item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-field">
              <button
                type="button"
                className="button button--primary button--icon-left"
                onClick={handleAddToBasket}
                data-test="add-to-basket-add"
              >
                <svg viewBox="0 0 36 32" width={24} height={22} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m39.0075 26.8324375 2.9545625-13c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-24.548875l-.572875-2.800625c-.14275-.6980625-.757-1.199375-1.4695625-1.199375h-6.4080625c-.8284375 0-1.5.6715625-1.5 1.5v1c0 .8284375.6715625 1.5 1.5 1.5h4.3676875l4.3905 21.4646875c-1.050375.6040625-1.7581875 1.7366875-1.7581875 3.0353125 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-.979625-.4029375-1.8646875-1.0515-2.5h13.1029375c-.6485.6353125-1.0514375 1.520375-1.0514375 2.5 0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5c0-1.38575-.8055-2.58325-1.9736875-3.1503125l.3448125-1.51725c.2133125-.938625-.500125-1.8324375-1.4626875-1.8324375h-16.776125l-.4090625-2h18.3215625c.700375 0 1.3075-.484625 1.4626875-1.1675625z"
                    fill="currentColor"
                    fillRule="evenodd"
                    transform="translate(-6 -8)"
                  />
                </svg>
                <span className="button__label">Add to order</span>
              </button>
            </div>
          </form>
        </div>

        {updateBasketQuantityError || (addBasketError && <Error message="Sorry something went wrong" />)}
      </Fragment>
    );
  };

  try {
    const domContainer = document.querySelector('#add-to-basket-dynamic');
    if (domContainer) {
      render(<AddToBasket />, domContainer);
    }
  } catch (e) {
    console.warn(e);
  }
}
